import axios from 'axios';
import storage from 'redux-persist/lib/storage';

import cookie from 'react-cookies';

import {
  LOGIN_TOOLS,
  LOGIN_TOOLS_SUCCESS,
  LOGIN_TOOLS_FAIL,
  TOOLS_FIELD_CHANGED,

  LOGOUT_TOOLS,
  AUTH_TOOLS_TOKEN_EXPIRY,

  TOOLS_ACCESS_USER_ACCOUNT_FAIL,
  TOOLS_ACCESS_USER_ACCOUNT_SUCCESS,

  TOOLS_ACCESS_PARTNER_ACCOUNT_FAIL,
  TOOLS_ACCESS_PARTNER_ACCOUNT_SUCCESS,

  TOOLS_HSA_SALES_FAIL,
  TOOLS_HSA_SALES_SUCCESS,

  TOOLS_HSA_ROUTES_FAIL,
  TOOLS_HSA_ROUTES_SUCCESS,

  TOOLS_HSA_GENERAL_FAIL,
  TOOLS_HSA_GENERAL_SUCCESS,

  TOOLS_HSA_TRANSFER_FAIL,
  TOOLS_HSA_TRANSFER_SUCCESS,

  TOOLS_AUDIT_CLAIMS_FAIL,
  TOOLS_AUDIT_CLAIMS_SUCCESS,

  TOOLS_AUDIT_CLAIM_DETAILS_FAIL,
  TOOLS_AUDIT_CLAIM_DETAILS_SUCCESS,

  TOOLS_AUDIT_CLAIM_DETAILS_PASS_SUCCESS,

  TOOLS_AUDIT_PAD_DETAILS_FAIL,
  TOOLS_AUDIT_PAD_DETAILS_SUCCESS,

  REPORT_PAD_REMOVE_DATA,

  TOOLS_API_TEST_FAIL,
  TOOLS_API_TEST_SUCCESS,

  TOOLS_AD_LIST_FAIL,
  TOOLS_AD_LIST_SUCCESS,

  TOOLS_UPDATE_ITEM_SUCCESS,
  TOOLS_UPDATE_ITEM_FAIL,
  TOOLS_REMOVE_UPDATE_ITEM_SUCCESS,
  TOOLS_REMOVE_UPDATE_ITEM_FAIL,
  TOOLS_UPDATE_LIST_SUCCESS,
  TOOLS_UPDATE_LIST_APPEND_FAIL,
  TOOLS_UPDATE_LIST_APPEND_SUCCESS,

  SNACKBAR_SET,
  GENERAL_REQUEST_LOADING,
  GENERAL_REQUEST_LOADED,
  MODAL_FORM_RESET
} from './types';
import history from '../utility/common/History.js';

const { REACT_APP_API_URL } = process.env;

// ********************************************************************************
// General Use
// ********************************************************************************

export const updateToolsField = (fieldName, fieldValue) => {
  return (dispatch) => {
    dispatch({
      type: TOOLS_FIELD_CHANGED,
      fieldName: fieldName,
      fieldValue: fieldValue
    })
  };
};

export const checkStaff = ({ id, pw }) => {
  return (dispatch) => {

    dispatch({ type: LOGIN_TOOLS });

    validateToolsLogin(dispatch, id, pw);

  };
};

export const logoutTools = (type) => {
  return (dispatch) => {
    dispatch({ type: LOGOUT_TOOLS });
    storage.removeItem('tools-token');
    storage.removeItem('tools-expiry');
    history.push('/tools/login');
  };
};

// ********************************************************************************
const validateToolsLogin = (dispatch, id, pw) => {

  let errors = {};

  if(id === 0 || id === '') errors.username = `Please fill out your username`;

  if(pw === 0 || pw === '') errors.password = 'Please fill out your password';

  if(Object.keys(errors).length > 0){
    errors.GENERAL = 'Please correct the information above'
    loginToolsFail(
      dispatch,
      true,
      errors
    );
  } else {
    authTools(dispatch, id, pw);
  }

};

const authTools = (dispatch, id, pw) => {

  axios.post(`${REACT_APP_API_URL}/tools/login/`, {
    id: id,
    pw: pw,
  })
  .then((response) => {
    if (response.data?.code === 0) {
      loginToolsSuccess(
        dispatch,
        response.data.data.username,
        response.data.data.permissions,
        response.data.data.token,
        response.data.data.expiry
      );
      storage.setItem('tools-token',response.data.data.token);
      storage.setItem('tools-expiry',response.data.data.expiry);
      cookie.save('tools-cookie', response.data.data.permissions.COOKIE_TOKEN, { path: '/' });
      history.push('/tools/');
    } else {
      loginToolsFail(
        dispatch,
        true,
        response.data?.data?.error
      );
    }
  })
  .catch((error) => {
    loginToolsFail(
      dispatch,
      true,
      error.response?.data?.data?.error
    );
  });
};

const loginToolsFail = (dispatch, error, errors) => {
  const apiErrors = errors && typeof errors === 'object' && !Array.isArray(errors) ? errors : {};
  const message = [apiErrors.GENERAL, apiErrors.message, errors].find(
    value => typeof value === 'string' && value.trim() !== ''
  ) || 'There was a problem connecting to the server, please contact Olympia Benefits.';

  dispatch({
    type: LOGIN_TOOLS_FAIL,
    error,
    errors: { ...apiErrors, GENERAL: message }
  });
  dispatch({
    type: SNACKBAR_SET,
    message,
    severity: 'notificationBarFailed',
    horizontal: 'center',
    vertical: 'bottom',
  });
};

const loginToolsSuccess = (
  dispatch,
  username,
  permissions,
  token,
  expiry
) => {
  dispatch({
    type: LOGIN_TOOLS_SUCCESS,
    username,
    permissions,
    token,
    expiry
  });
};

export const toolsAPITester = (fullurl, method, data, token) => {
  if(!data['token']){
    data['token'] = token;
  }
  console.log({ ...data, data: { ...data }});

  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });

    if(method === 'post'){
      axios.post(`${fullurl}`, {
        ...data,
        data: { ...data },
      })
      .then((response) => {
        if (response.data.code === 0) {
          dispatch({ type: GENERAL_REQUEST_LOADED });
          dispatch({
            type: TOOLS_API_TEST_SUCCESS,
            data: response.data.data,
          });
          dispatch({
            type: SNACKBAR_SET,
            message: 'Api Test Successful',
            severity: 'notificationBarSuccess',
            horizontal: 'center',
            vertical: 'bottom',
          });
        } else {
          dispatch({ type: GENERAL_REQUEST_LOADED });
          dispatch({
            type: TOOLS_API_TEST_FAIL,
            error: true,
            errors: response.data.data.error
          });
          dispatch({
            type: SNACKBAR_SET,
            message: 'Api Test Fail',
            severity: 'notificationBarFailed',
            horizontal: 'center',
            vertical: 'bottom',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: GENERAL_REQUEST_LOADED });
        dispatch({
          type: SNACKBAR_SET,
          message: 'Api Test Network Failure:'+ error,
          severity: 'notificationBarFailed',
          horizontal: 'center',
          vertical: 'bottom',
        });
      });
    }
    else {
      axios.get(`${fullurl}`)
      .then((response) => {
        if (response.data.code === 0) {
          dispatch({ type: GENERAL_REQUEST_LOADED });
          dispatch({
            type: TOOLS_API_TEST_SUCCESS,
            data: response.data.data,
          });
          dispatch({
            type: SNACKBAR_SET,
            message: 'Api Test Successful',
            severity: 'notificationBarSuccess',
            horizontal: 'center',
            vertical: 'bottom',
          });
        } else {
          dispatch({ type: GENERAL_REQUEST_LOADED });
          dispatch({
            type: TOOLS_API_TEST_FAIL,
            error: true,
            errors: response.data.data.error
          });
          dispatch({
            type: SNACKBAR_SET,
            message: 'Api Test Fail',
            severity: 'notificationBarFailed',
            horizontal: 'center',
            vertical: 'bottom',
          });

        }
      })
      .catch((error) => {
        dispatch({ type: GENERAL_REQUEST_LOADED });
        dispatch({
          type: SNACKBAR_SET,
          message: 'Api Test Network Failure:'+ error,
          severity: 'notificationBarFailed',
          horizontal: 'center',
          vertical: 'bottom',
        });
      });
    }
  }
}

const toolsAPI = (dispatch, data, token, endpoint, reducerActions, showSnackbar={success:true}, redirectActions, isCookieToken=false) => {
  axios.post(`${REACT_APP_API_URL}${endpoint}`, {
    data: data,
    token: token
  },{ headers: { token: token } })
  .then((response) => {
    if (response.data.code === 0) {
      if (!isCookieToken) updateToolsTokenExpiration(dispatch, response.data.data.TOKEN_EXPIRY);
      toolsChangeSuccess(
        dispatch,
        response.data.data,
        reducerActions.success,
        showSnackbar
      );
      storage.setItem('token',response.data.data.token);
      storage.setItem('expiry',response.data.data.expiry);
      if (redirectActions && redirectActions.success){
        if (redirectActions.behaviour && redirectActions.behaviour.success === 'newWindow'){
          const win = window.open(redirectActions.success, "_blank");
          win.focus();
        }
        else {
          history.push(redirectActions.success);
        }
      }
    }
    else {
      toolsChangeFail(
        dispatch,
        reducerActions.error,
        true,
        response.data.data.error,
        showSnackbar
      );
      if(response.data.data.error.FORCE_LOGOUT){
        // dispatch({
        //   type: LOGOUT,
        // });
        history.push('/tools/logout');
      }
      else if (redirectActions && redirectActions.error){
        if (redirectActions.behaviour && redirectActions.behaviour.error === 'newWindow'){
          const win = window.open(redirectActions.error, "_blank");
          win.focus();
        }
        else {
          history.push(redirectActions.error);
        }
      }
    }
  })
  .catch((error) => {
    toolsChangeFail(
      dispatch,
      true,
      error
    );
    if (redirectActions && redirectActions.error){
      if (redirectActions.behaviour && redirectActions.behaviour.error === 'newWindow'){
        const win = window.open(redirectActions.error, "_blank");
        win.focus();
      }
      else{
        history.push(redirectActions.error);
      }
    }
  });

  const toolsChangeSuccess = (
    dispatch,
    data,
    successType,
    showSnackbar
  ) => {
    dispatch({
      type: successType,
      data,
    });
    dispatch({
      type: MODAL_FORM_RESET,
    });
    dispatch({ type: GENERAL_REQUEST_LOADED });
    if(showSnackbar && showSnackbar.success){
      dispatch({
        type: SNACKBAR_SET,
        message: data.message,
        severity: 'notificationBarSuccess',
        horizontal: 'center',
        vertical: 'bottom',
      });
    }
  };

  const toolsChangeFail = (dispatch, failType, error, errors, showSnackbar) => {
    dispatch({
      type: failType,
      error,
      errors
    });
    dispatch({ type: GENERAL_REQUEST_LOADED });
    if(showSnackbar && showSnackbar.error){
      dispatch({
        type: SNACKBAR_SET,
        message: errors.message,
        severity: 'notificationBarFailed',
        horizontal: 'center',
        vertical: 'bottom',
      });
    }
  };
}

/*-------------------------------------------------------------------*/
export const toolsLoginUserAccount = (token, toolsUser, accessUserId, accessUserType) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser, accessUserId: accessUserId, accessUserType: accessUserType};
    const endpoint = '/tools/access-user';
    const reducerTypes = (accessUserType === 'AGENT')?
    {error: TOOLS_ACCESS_PARTNER_ACCOUNT_FAIL, success: TOOLS_ACCESS_PARTNER_ACCOUNT_SUCCESS}:
    {error: TOOLS_ACCESS_USER_ACCOUNT_FAIL, success: TOOLS_ACCESS_USER_ACCOUNT_SUCCESS};
    const showSnackbar = {error: true, success: true};
    const redirectURLs = { error: null, success: (accessUserType === 'AGENT')? '/partner/' : '/' }
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar, redirectURLs);
  }
}

/*-------------------------------------------------------------------*/
export const toolsGetAds = (token, toolsUser, adData) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser, ...adData};
    const endpoint = '/tools/ads/list';
    const reducerTypes = {error: TOOLS_AD_LIST_FAIL, success: TOOLS_AD_LIST_SUCCESS};
    const showSnackbar = {error: true, success: false};
    const redirectURLs = { error: null, success: null};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar, redirectURLs);
  }
}

/*-------------------------------------------------------------------*/
export const toolsCreateAd = (token, toolsUser, adData) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser, ...adData};
    const endpoint = '/tools/ads/add';
    const reducerTypes = {error: TOOLS_AD_LIST_FAIL, success: TOOLS_AD_LIST_SUCCESS};
    const showSnackbar = {error: true, success: true};
    const redirectURLs = { error: null, success: '/tools/ads'};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar, redirectURLs);
  }
}
/*-------------------------------------------------------------------*/
export const toolsSaveAd = (token, toolsUser, adData) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser, ...adData};
    const endpoint = '/tools/ads/edit';
    const reducerTypes = {error: TOOLS_AD_LIST_FAIL, success: TOOLS_AD_LIST_SUCCESS};
    const showSnackbar = {error: true, success: true};
    const redirectURLs = { error: null, success: '/tools/ads'};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar, redirectURLs);
  }
}

/*-------------------------------------------------------------------*/
export const toolsRemoveAd = (token, toolsUser, adData) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser, ...adData};
    const endpoint = '/tools/ads/remove';
    const reducerTypes = {error: TOOLS_AD_LIST_FAIL, success: TOOLS_AD_LIST_SUCCESS};
    const showSnackbar = {error: true, success: true};
    const redirectURLs = { error: null, success: '/tools/ads'};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar, redirectURLs);
  }
}

/*-------------------------------------------------------------------*/
export const toolsGetUpdates = (token, toolsUser, fetchStart, fetchLength, versionQuery) => {
  return (dispatch) => {
    if(fetchStart == 1 || fetchStart == 0){
      dispatch({ type: TOOLS_UPDATE_LIST_SUCCESS, data: { updateItems: [] }});
    }
    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser, fetchStart: fetchStart, fetchLength: fetchLength, versionQuery: versionQuery};
    const endpoint = '/tools/updates/list';
    const reducerTypes = {error: TOOLS_UPDATE_LIST_APPEND_FAIL, success: TOOLS_UPDATE_LIST_APPEND_SUCCESS};
    const showSnackbar = {error: true, success: false};
    const redirectURLs = { error: null, success: null};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar, redirectURLs);
  }
}

/*-------------------------------------------------------------------*/
  export const toolsRemoveUpdate = (token, toolsUser, UPDATEID) => {
    return (dispatch) => {

      dispatch({ type: GENERAL_REQUEST_LOADING });
      const data = {toolsUser: toolsUser, UPDATEID: UPDATEID};
      const endpoint = '/tools/updates/remove';
      const reducerTypes = {error: TOOLS_REMOVE_UPDATE_ITEM_FAIL, success: TOOLS_REMOVE_UPDATE_ITEM_SUCCESS};
      const showSnackbar = {error: true, success: true};
      const redirectURLs = { error: null, success: '/tools/updates'};
      toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar, redirectURLs);
    }
  }
/*-------------------------------------------------------------------*/
  export const toolsSaveUpdate = (token, toolsUser, updateData) => {
    return (dispatch) => {

      dispatch({ type: GENERAL_REQUEST_LOADING });
      const data = {toolsUser: toolsUser, ...updateData};
      const endpoint = '/tools/updates/edit';
      const reducerTypes = {error: TOOLS_UPDATE_ITEM_FAIL, success: TOOLS_UPDATE_ITEM_SUCCESS};
      const showSnackbar = {error: true, success: true};
      const redirectURLs = { error: null, success: '/tools/updates'};
      toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar, redirectURLs);
    }
  }
/*-------------------------------------------------------------------*/
  export const toolsCreateUpdate = (token, toolsUser, updateData) => {
    return (dispatch) => {

      dispatch({ type: GENERAL_REQUEST_LOADING });
      const data = {toolsUser: toolsUser, ...updateData};
      const endpoint = '/tools/updates/add';
      const reducerTypes = {error: TOOLS_UPDATE_ITEM_FAIL, success: TOOLS_UPDATE_ITEM_SUCCESS};
      const showSnackbar = {error: true, success: true};
      const redirectURLs = { error: null, success: '/tools/updates'};
      toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar, redirectURLs);
    }
  }

/*-------------------------------------------------------------------*/
export const toolsFetchSales = (cookieToken) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {};
    const endpoint = '/tools/fetch-sales';
    const reducerTypes = {error: TOOLS_HSA_SALES_FAIL, success: TOOLS_HSA_SALES_SUCCESS};
    const showSnackbar = {error: true, success: false};
    const redirectActions = {error: '/tools/login', success: null}
    toolsAPI(dispatch, data, cookieToken, endpoint, reducerTypes, showSnackbar, redirectActions, true);
  }
}

/*-------------------------------------------------------------------*/
export const toolsRecalculateEmployeeLimits = (token, toolsUser, employee) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser, employee: employee};
    const endpoint = '/tools/recal-employee-limit';
    const reducerTypes = {error: TOOLS_HSA_GENERAL_FAIL, success: TOOLS_HSA_GENERAL_SUCCESS};
    const showSnackbar = {error: true, success: true};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar);
  }
}

/*-------------------------------------------------------------------*/
export const toolsSendReceipt = (token, toolsUser, employer) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser, employer: employer};
    const endpoint = '/tools/send-receipt';
    const reducerTypes = {error: TOOLS_HSA_GENERAL_FAIL, success: TOOLS_HSA_GENERAL_SUCCESS};
    const showSnackbar = {error: true, success: true};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar);
  }
}

/*-------------------------------------------------------------------*/
export const toolsResendWelcome = (token, toolsUser, id, type) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = { toolsUser };
    const endpoint = '/tools/welcome/resend/'+type+'/'+id
    const reducerTypes = {error: TOOLS_HSA_GENERAL_FAIL, success: TOOLS_HSA_GENERAL_SUCCESS};
    const showSnackbar = {error: true, success: true};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar);
  }
}

/*-------------------------------------------------------------------*/
export const toolsSendPartnerReceipt = (token, toolsUser, applicationId) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser, applicationId: applicationId};
    const endpoint = '/tools/send-receipt-partner';
    const reducerTypes = {error: TOOLS_HSA_GENERAL_FAIL, success: TOOLS_HSA_GENERAL_SUCCESS};
    const showSnackbar = {error: true, success: true};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar);
  }
}

/*-------------------------------------------------------------------*/
export const toolsApiRoutes = (token, toolsUser) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser};
    const endpoint = '/tools/api-routes';
    const reducerTypes = {error: TOOLS_HSA_ROUTES_FAIL, success: TOOLS_HSA_ROUTES_SUCCESS};
    const showSnackbar = {error: true, success: true};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar);
  }
}


/*-------------------------------------------------------------------*/
export const toolsGetTransferDetails = (token, toolsUser, transferId) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser, transferId: transferId};
    const endpoint = '/tools/transfer-details';
    const reducerTypes = {error: TOOLS_HSA_TRANSFER_FAIL, success: TOOLS_HSA_TRANSFER_SUCCESS};
    const showSnackbar = {error: true, success: true};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar);
  }
}


/*-------------------------------------------------------------------*/
export const toolsGetAuditClaims = (token, toolsUser) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser};
    const endpoint = '/tools/get-audit-claims';
    const reducerTypes = {error: TOOLS_AUDIT_CLAIMS_FAIL, success: TOOLS_AUDIT_CLAIMS_SUCCESS};
    const showSnackbar = {error: true, success: true};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar);
  }
}

/*-------------------------------------------------------------------*/
export const toolsGetAuditClaimDetails = (token, toolsUser, claimId) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser, claimId: claimId};
    const endpoint = '/tools/audit-claim/get';
    const reducerTypes = {error: TOOLS_AUDIT_CLAIM_DETAILS_FAIL, success: TOOLS_AUDIT_CLAIM_DETAILS_SUCCESS};
    const showSnackbar = {error: true, success: true};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar);
  }
}

/*-------------------------------------------------------------------*/
export const toolsAuditClaimDetermination = (token, toolsUser, claimId, auditAction) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser, claimId: claimId};
    const endpoint = (auditAction === 'Pass')? '/tools/audit-claim/pass' : '/tools/audit-claim/fail';
    const reducerTypes = {error: TOOLS_HSA_GENERAL_FAIL, success: TOOLS_AUDIT_CLAIM_DETAILS_PASS_SUCCESS};
    const redirectActions = {error: null, success: '/tools/audit/claims'}
    const showSnackbar = {error: true, success: true};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar, redirectActions);
  }
}

/*-------------------------------------------------------------------*/
export const toolsGetAuditPADDetails = (token, toolsUser, id, type) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser, id: id, type: type};
    const endpoint = '/tools/audit-pad/get';
    const reducerTypes = {error: TOOLS_AUDIT_PAD_DETAILS_FAIL, success: TOOLS_AUDIT_PAD_DETAILS_SUCCESS};
    const showSnackbar = {error: true, success: true};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar);
  }
}

/*-------------------------------------------------------------------*/
export const toolsAuditPADDetermination = (token, toolsUser, id, type, auditAction, selectedOptions) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });
    const data = {toolsUser: toolsUser, id: id, type: type, options: selectedOptions};
    const endpoint = (auditAction === 'Pass')? '/tools/audit-pad/pass' : '/tools/audit-pad/fail';
    const reducerTypes = (auditAction != 'Pass')? {error: TOOLS_HSA_GENERAL_FAIL, success: TOOLS_HSA_GENERAL_SUCCESS} :  {error: TOOLS_HSA_GENERAL_FAIL, success: REPORT_PAD_REMOVE_DATA};
    const showSnackbar = {error: true, success: true};
    const redirectActions = {error: null, success: '/tools/pad-audit/'+ String.prototype.toLowerCase.apply(type)};
    toolsAPI(dispatch, data, token, endpoint, reducerTypes, showSnackbar, redirectActions);

  }
}

/*--------------------------------- Tools Token -----------------------------------------*/
export const updateToolsTokenExpiration = (dispatch, token_expiry) => {
  dispatch({
    type: AUTH_TOOLS_TOKEN_EXPIRY,
    expiry: token_expiry
  });
};
